$(document).ready(function () {
	$('.nominate-form__input[name=department]').hide();
    $('.nominate-form__input[name=department]').val('Afdelingscheck');

    $('.nominate-form').submit(function(e) {
        e.preventDefault();
        $('.nominate-form__submit').addClass('nominate-form__submit--loading');

        $.post('/nominate/submit', $(this).serialize(), function(res) {
            res = $.parseJSON(res);
            if (res.status != 'success') {
                var errorMessage = res.error || 'Er ging iets mis met je nominatie. Probeer het op een later moment opnieuw.';
                console.log(errorMessage);
                $('.hero__side-form').hide();
                $('.hero__side-error').show();
            } else {
                $('.hero__side-form').hide();
                $('.hero__side-thanks').show();
            }
        });
    })

    $(".js-nominate-form-restart").click(function(e) {
        e.preventDefault();
        $('.hero__side-form').show();
        $('.hero__side-thanks').hide();
        $('.hero__side-error').hide();
        //reset form
        $('.nominate-form').trigger('reset');
        $('.nominate-form__input[name=department]').val('Afdelingscheck');
        $('.nominate-form__submit').removeClass('nominate-form__submit--loading');
    })
})



// WEBPACK FOOTER //
// ./app/src/assets/js/partials/nominateForm.js